import React, { Component } from "react";
import DynamicListView from "../CommonComponentListView/DynamicListView";
import Service from "../../../services";
import { AxiosError } from "axios";
import { accounts } from "../../../models/AccountsModel";
import "./AccountsTab.scss";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { catchError } from "../../../utils/Utils";
import { ColumnConfig } from "../../../models/ActionModel";
import FinSpinner from "../../../commonfields/FinSpinner";

interface initialProps{
  refreshComponent:boolean;
  context:any;
}


interface accountsState {
    accountsData: accounts[];
  otherAccountsData:accounts[];
  columnNames: ColumnConfig[];
  loader:boolean;
}

class AccountsMainCC extends Component<
WithRouterProps<initialProps>,
  accountsState
> {
    service:Service;
  constructor(props: any) {
    super(props);
    this.state = {
        otherAccountsData: [ ],
        accountsData:[],
      columnNames: [
        {
          label: "account",
          displayText: 3,
          columnStyling: "accountItemContainer",
          textStyling: "accountName",
          orderId:1
        },

        {
            label: "merchantname",
            displayText: 1,
            columnStyling: "",
            textStyling: "",
            orderId:2,
            displayLabelText:"MERCHANT NAME"
          },

          {
            label: "salesperson",
            displayText: 1,
            columnStyling: "",
            textStyling: "",
            orderId:3,
            displayLabelText:"SALES PERSON"
          },
          {
            label: "lor",
            displayText: 1,
            columnStyling: "",
            textStyling: "",
            orderId:4,
            displayLabelText:"Status"
          },

      ],
      loader:false
    };
    this.service=new Service();
  }

  componentDidMount(): void {

    const data= {
        "screen":"ProspectDetails",
        "sections":"GetClientAccounts",
        "clientId":this.props.params.clientId
    }
    this.setState({loader:true})

      this.service.getAccountsData(data).then((response:any)=>{
        this.setState({accountsData:response.data})
      }).catch((error:AxiosError)=>{
        catchError(error,true);
      }).finally(()=>{
        this.setState({loader:false})

      })

  }

  componentDidUpdate(prevProps: Readonly<WithRouterProps<initialProps>>, prevState: Readonly<accountsState>, snapshot?: any): void {
    if(prevProps.refreshComponent!=this.props.refreshComponent){
      const data= {
        "screen":"ProspectDetails",
        "sections":"GetClientAccounts",
        "clientId":this.props.params.clientId
    }
    this.setState({loader:true})

      this.service.getAccountsData(data).then((response:any)=>{
        this.setState({accountsData:response.data})
      }).catch((error:AxiosError)=>{
        catchError(error,true);
      }).finally(()=>{
        this.setState({loader:false})

      })
    }
  }


  render() {
    const {accountsData}=this.state;
    return (
      <>
      {this.state.loader&&<FinSpinner/>}
      {accountsData?<div>
        <p className="accountText">Accounts: {this.state.accountsData.length}</p>
        <div className="accountsTabContainer"> 
        <div>
            <p className="presentAccountText">THIS ACCOUNT</p>
            <DynamicListView
          tilesData={accountsData?.filter((m:accounts)=>m.clientid===this.props.params.clientId)}
          columnNames={this.state.columnNames}
          className={"accountsTile"}
        />
        </div>

        <div className="otherAccountsContainer">
            <p className="presentAccountText otherAccountText">OTHER ACCOUNTS ({accountsData?.filter((m:accounts)=>m.clientid!==this.props.params.clientId).length})</p>
            <DynamicListView
          tilesData={accountsData?.filter((m:accounts)=>m.clientid!==this.props.params.clientId)}
          columnNames={this.state.columnNames}
          className={"accountsTile"}
        />
        </div>
        </div>       
      </div>:<div className='noRecordsContainer'>
       <p className="not-found">
        No Records 
       </p>      
      </div>}
      </>
    );
  }
}

export default withRouter<WithRouterProps<initialProps>>(AccountsMainCC)
